import React from 'react';
import { Link } from 'react-router-dom'
import { companyNew, policyStudy, IndustryNews } from "@/fetch";

class news extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      newsList: [],
    }
  }
  getCompanyNewsByCondition() {
    return new Promise((resolve, reject) => {
      companyNew.getCompanyNewsByCondition({ page: 1, size: 1 }).then(res => {
        res.page.content[0].href = '/Introduction/CompanyNews/NewsDetail/'
        resolve(res.page.content)
      }).catch(err => reject(err))
    });
  }
  getIndustryNewsByCondition() {
    return new Promise((resolve, reject) => {
      IndustryNews.getIndustryNewsByCondition({ page: 1, size: 1 }).then(res => {
        res.page.content[0].href = '/News/Industry/NewsDetail/'
        resolve(res.page.content)
      }).catch(err => reject(err))
    });
  }
  getPolicyStudyByCondition() {
    return new Promise((resolve, reject) => {
      policyStudy.getPolicyStudyByCondition({ page: 1, size: 1 }).then(res => {
        res.page.content[0].href = '/News/Policy/NewsDetail/'
        resolve(res.page.content)
      }).catch(err => reject(err))
    });
  }
  async componentWillMount() {
    this._isMounted = true
    // 新闻顺序有要求，其中一个新闻请求失败时，不能影响其他新闻的请求
    const CompanyNews = await this.getCompanyNewsByCondition().catch(err => console.log(err)) || []
    const IndustryNews = await this.getIndustryNewsByCondition().catch(err => console.log(err)) || []
    const PolicyStudy = await this.getPolicyStudyByCondition().catch(err => console.log(err)) || []
    this._isMounted && this.setState({
      newsList: [...this.state.newsList, ...CompanyNews, ...IndustryNews, ...PolicyStudy]
    })
  }
  componentWillUnmount() {
    this._isMounted = false
  }
  render() {
    return (
      <section className="news">
        <h4 className="title">
          <Link to="/Introduction/CompanyNews">热门资讯</Link>
        </h4>
        <ul>
          {
            this.state.newsList.map((item, index) =>
              <li key={index}>
                <Link to={item.href + item.id}>
                  <div>
                    <h5>{item.title}</h5>
                    <span>发布时间 {item.publishAt && item.publishAt.slice(0, 10)}</span>
                  </div>
                  {item.href !== '/Introduction/CompanyNews/NewsDetail/' && item.accessPath && <img src={item.accessPath} alt="" />}
                </Link>
              </li>
            )
          }
        </ul>
      </section>
    );
  }
}

export default news;
